import { createBrowserAnalytics } from '@asurion-core/analytics-browser-writers';

/**
 * Analytics service for the sales tool with error handling. Falls back to
 * console logging if analytics endpoint is unavailable.
 */
function createAnalyticsWithFallback() {
  try {
    return createBrowserAnalytics({
      httpUrl: '/api/analytics',
      scope: 'expert-sales-tool',
      sourceApp: 'sales-tool',
    });
  } catch (error) {
    console.warn('Analytics initialization failed, using fallback:', error);

    // Fallback analytics that logs to console instead of making HTTP requests
    return {
      track: (event: string, data?: any) => {
        console.log('Analytics Event:', event, data);
        return Promise.resolve();
      },
      identify: (userId: string, data?: any) => {
        console.log('Analytics Identify:', userId, data);
        return Promise.resolve();
      },
      // Add other methods that might be used
      page: (data?: any) => {
        console.log('Analytics Page:', data);
        return Promise.resolve();
      },
    };
  }
}

export const analytics = createAnalyticsWithFallback();
